/**
 * Function to determine if Darwin test is on or off. If test name exists
 * also in winners, the winners value is taken into account (winner has
 * higher priority than test).
 *
 * This function is used ony inside redux actions or selectors, otherwise
 * prefer to use Darwin's `useTest` directly if possible (in components, hooks).
 *
 * In case you only use `isDarwinTestOn` function, make sure that `useTest` hook
 * is called at least once in your module component to get properly triggered
 * to session storage and tracked into globals.
 *
 * @param testName - name of the Darwin test
 * @return true if passed Darwin winner or test is on (winner has higher priority)
 */
export const isDarwinTestOn = (testName: string): boolean => {
  // TODO add Darwin to redux https://jira.kiwi.com/browse/MMB-2693
  // @ts-expect-error: Flow to TS migration.
  const { tests, winners } = window.__DARWIN__ ?? {}

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const winner = winners?.find((w: any) => w.name === testName)

  return winner
    ? winner.value === "on"
    : // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tests?.find((test: any) => test.name === testName)?.value === "on"
}

export const isDarwinFeatureOn = (featureName: string): boolean => {
  // TODO add Darwin to redux https://jira.kiwi.com/browse/MMB-2693
  // @ts-expect-error: Flow to TS migration.
  const { features = {} } = window.__DARWIN__ ?? {}

  return features[featureName] || false
}
